import { Store } from '@ngrx/store';
import { takeUntil } from 'rxjs/operators';
// Interfaces / Types / Enums
import { FolderableOperationValue } from 'FoldersApp/state/folderable-operation/folderable-operation-value.enum';
// Services
import { AccountsService } from 'AccountsApp/ts/services/accounts.service';
import { BulkActionSelectionService } from 'FoldersApp/services/bulk-action-selection.service';
import { FolderableCollectionLoadOnScrollServiceBase } from 'FoldersApp/services/folderable-collection-load-on-scroll-service-base.service';
import { FolderableCollectionServiceBase } from 'FoldersApp/services/folderable-collection-service-base.service';
import { SelectedFolderableService } from 'FoldersApp/services/selected-folderable.service';
// Components / Directives
import { FolderableSavedModalBaseDirective } from 'FoldersApp/features/folders-shared/folderable-open-saved-modal/folderable-saved-base.directive';
import * as i0 from "@angular/core";
import * as i1 from "AccountsApp/ts/services/accounts.service";
import * as i2 from "FoldersApp/services/bulk-action-selection.service";
import * as i3 from "FoldersApp/services/folderable-collection-load-on-scroll-service-base.service";
import * as i4 from "FoldersApp/services/selected-folderable.service";
import * as i5 from "@ngrx/store";
import * as i6 from "@angular/common";
import * as i7 from "../../../../../../ycharts/static/ts/features/directives/infinite-scroll/infinite-scroll.directive";
import * as i8 from "../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i9 from "../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-header.component";
import * as i10 from "FoldersApp/features/folders-shared/folderable-bulk-action-menu/folderable-bulk-action-menu.component";
import * as i11 from "FoldersApp/features/folders-shared/folderable-column-headers-component/folderable-column-headers.component";
import * as i12 from "FoldersApp/features/folders-shared/folderable-move-modal/folderable-move-modal.component";
import * as i13 from "FoldersApp/features/folders-shared/folder-breadcrumb/folder-breadcrumb.component";
import * as i14 from "FoldersApp/features/folders-shared/folder-create/folder-create.component";
const _c0 = a0 => ({ "visibility": a0 });
const _c1 = (a0, a1, a2) => ({ id: a0, name: a1, permissions: a2 });
const _c2 = (a0, a1) => ({ folderable: a0, ancestorInfo: a1 });
function _forTrack0($index, $item) { return this.trackFolderable($item); }
function FolderableOpenSavedModalComponent_Conditional_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 3);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.filterFragment);
} }
function FolderableOpenSavedModalComponent_Conditional_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtext(1, "Search Results");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("hidden", !ctx_r0.folderableCollectionService.textSearchActive);
} }
function FolderableOpenSavedModalComponent_Conditional_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-folder-breadcrumb", 7);
} if (rf & 2) {
    i0.ɵɵproperty("displayFlex", false);
} }
function FolderableOpenSavedModalComponent_div_14_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵlistener("setSort", function FolderableOpenSavedModalComponent_div_14_Template_div_setSort_0_listener($event) { i0.ɵɵrestoreView(_r2); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.setSort($event)); });
    i0.ɵɵelement(1, "th", 17);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("columnConfig", ctx_r0.columnConfig)("sortableColumns", ctx_r0.sortableColumns)("sortColumn", ctx_r0.folderableCollectionService.dataParams.sortColumn)("sortDirection", ctx_r0.folderableCollectionService.dataParams.sortDirection);
} }
function FolderableOpenSavedModalComponent_Conditional_16_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18)(1, "span");
    i0.ɵɵtext(2, "There are no items.");
    i0.ɵɵelementEnd()();
} }
function FolderableOpenSavedModalComponent_Conditional_16_Conditional_1_For_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 19);
} if (rf & 2) {
    const folderable_r3 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.listItemFragment)("ngTemplateOutletContext", i0.ɵɵpureFunction2(6, _c2, folderable_r3, i0.ɵɵpureFunction3(2, _c1, ctx_r0.folderableCollectionService.viewRootFolder.id, ctx_r0.folderableCollectionService.viewRootFolder.name, ctx_r0.folderableCollectionService.viewRootFolder.permissions)));
} }
function FolderableOpenSavedModalComponent_Conditional_16_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, FolderableOpenSavedModalComponent_Conditional_16_Conditional_1_For_1_Template, 1, 9, "ng-container", 19, _forTrack0, true);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵrepeater(ctx_r0.folderableCollectionService.items);
} }
function FolderableOpenSavedModalComponent_Conditional_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵconditionalCreate(0, FolderableOpenSavedModalComponent_Conditional_16_Conditional_0_Template, 3, 0, "div", 18)(1, FolderableOpenSavedModalComponent_Conditional_16_Conditional_1_Template, 2, 0);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(!ctx_r0.folderableCollectionService.loading && ctx_r0.folderableCollectionService.items.length === 0 ? 0 : 1);
} }
function FolderableOpenSavedModalComponent_Conditional_17_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 3);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.userHasNoDataFragment);
} }
function FolderableOpenSavedModalComponent_Conditional_17_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵtext(1, " No Results.");
    i0.ɵɵelement(2, "br");
    i0.ɵɵelementStart(3, "span")(4, "a", 21);
    i0.ɵɵlistener("click", function FolderableOpenSavedModalComponent_Conditional_17_Conditional_1_Template_a_click_4_listener() { i0.ɵɵrestoreView(_r4); const ctx_r0 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r0.clearFilters()); });
    i0.ɵɵtext(5, "Clear Filters");
    i0.ɵɵelementEnd()()();
} }
function FolderableOpenSavedModalComponent_Conditional_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵconditionalCreate(0, FolderableOpenSavedModalComponent_Conditional_17_Conditional_0_Template, 1, 1, "ng-container", 3)(1, FolderableOpenSavedModalComponent_Conditional_17_Conditional_1_Template, 6, 0, "div", 20);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.folderableCollectionService.userHasNoData ? 0 : 1);
} }
function FolderableOpenSavedModalComponent_Conditional_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0, 3);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.loadingFragment);
} }
function FolderableOpenSavedModalComponent_Conditional_19_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵlistener("fetchMoreItemsHandler", function FolderableOpenSavedModalComponent_Conditional_19_Template_div_fetchMoreItemsHandler_0_listener() { i0.ɵɵrestoreView(_r5); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.folderableCollectionService.loadItems(true, true)); });
    i0.ɵɵelementEnd();
} }
/**
 * Modal used to open a saved folderable item on a modal page (ex: Fundamental Chart page).
 * - Clicking a non-folder item opens the item on the page, and closes the modal.
 *
 * Usage
 * - The component rendered in `listItemFragment` should use an instance of `SelectedFolderableService`
 *   to open an item.
 */
export class FolderableOpenSavedModalComponent extends FolderableSavedModalBaseDirective {
    constructor(accountsService, bulkActionSelectionService, folderableCollectionService, selectedFolderableService, store) {
        super(accountsService, folderableCollectionService, selectedFolderableService, store);
        this.accountsService = accountsService;
        this.bulkActionSelectionService = bulkActionSelectionService;
        this.folderableCollectionService = folderableCollectionService;
        this.selectedFolderableService = selectedFolderableService;
        this.store = store;
        this.folderableOperationValue = FolderableOperationValue.OPEN;
    }
    ngOnInit() {
        super.ngOnInit();
        this.folderableCollectionService.viewResponse$
            .pipe(takeUntil(this.unsubscribe))
            .subscribe((response) => {
            if (response && 'page' in response.params && response.params.page === 1) {
                this.bulkActionSelectionService.clearSelections();
            }
        });
        this.selectedFolderableService.selectedFolderable$.pipe(takeUntil(this.unsubscribe)).subscribe(() => {
            // After the user makes a selection, close the modal.
            this.close();
        });
    }
    close() {
        super.close();
        this.bulkActionSelectionService.clearSelections();
        this.bulkActionSelectionService.setBulkActionEnabled(false);
    }
}
FolderableOpenSavedModalComponent.ɵfac = function FolderableOpenSavedModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FolderableOpenSavedModalComponent)(i0.ɵɵdirectiveInject(i1.AccountsService), i0.ɵɵdirectiveInject(i2.BulkActionSelectionService), i0.ɵɵdirectiveInject(i3.FolderableCollectionLoadOnScrollServiceBase), i0.ɵɵdirectiveInject(i4.SelectedFolderableService), i0.ɵɵdirectiveInject(i5.Store)); };
FolderableOpenSavedModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FolderableOpenSavedModalComponent, selectors: [["ycn-folderable-open-saved-modal"]], standalone: false, features: [i0.ɵɵProvidersFeature([{ provide: FolderableCollectionLoadOnScrollServiceBase, useExisting: FolderableCollectionServiceBase }]), i0.ɵɵInheritDefinitionFeature], decls: 21, vars: 19, consts: [[3, "closeModalHandler", "modalBaseClass", "extraModalClasses", "open"], [3, "closeModalHandler", "header", "showUnsavedStatus"], [1, "modal-body"], [3, "ngTemplateOutlet"], [1, "modal-section", "pb-10"], [1, "modal-section-header"], [1, "file-path", "text-bold", 3, "hidden"], [3, "displayFlex"], [3, "visibleFlex"], [1, "bg-yc-blue-75", 3, "ngStyle"], [1, "page-progress-bar"], [1, "table", "file-table", 3, "id"], ["class", "thead", "ycn-folderable-column-headers", "", 3, "columnConfig", "sortableColumns", "sortColumn", "sortDirection", "setSort", 4, "ngIf"], [1, "tbody"], ["ycnInfiniteScroll", ""], [2, "z-index", "10000"], ["ycn-folderable-column-headers", "", 1, "thead", 3, "setSort", "columnConfig", "sortableColumns", "sortColumn", "sortDirection"], [1, "th", "col-1"], [1, "get-started-small", "flex-auto"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "get-started", "flex-auto", "min-height-220"], ["href", "javascript:void(0)", 1, "text-blue", 3, "click"], ["ycnInfiniteScroll", "", 3, "fetchMoreItemsHandler"]], template: function FolderableOpenSavedModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ycn-modal-base", 0);
        i0.ɵɵlistener("closeModalHandler", function FolderableOpenSavedModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { return ctx.close(); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 1);
        i0.ɵɵlistener("closeModalHandler", function FolderableOpenSavedModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { return ctx.close(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵconditionalCreate(3, FolderableOpenSavedModalComponent_Conditional_3_Template, 1, 1, "ng-container", 3);
        i0.ɵɵelementStart(4, "div", 4)(5, "div", 5);
        i0.ɵɵconditionalCreate(6, FolderableOpenSavedModalComponent_Conditional_6_Template, 2, 1, "div", 6)(7, FolderableOpenSavedModalComponent_Conditional_7_Template, 1, 1, "ycn-folder-breadcrumb", 7);
        i0.ɵɵelement(8, "ycn-folder-create", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "div", 9);
        i0.ɵɵelement(10, "div", 10);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(11, "ycn-folderable-bulk-action-menu");
        i0.ɵɵelementStart(12, "div", 11);
        i0.ɵɵpipe(13, "async");
        i0.ɵɵtemplate(14, FolderableOpenSavedModalComponent_div_14_Template, 2, 4, "div", 12);
        i0.ɵɵelementStart(15, "div", 13);
        i0.ɵɵconditionalCreate(16, FolderableOpenSavedModalComponent_Conditional_16_Template, 2, 1)(17, FolderableOpenSavedModalComponent_Conditional_17_Template, 2, 1);
        i0.ɵɵconditionalCreate(18, FolderableOpenSavedModalComponent_Conditional_18_Template, 1, 1, "ng-container", 3)(19, FolderableOpenSavedModalComponent_Conditional_19_Template, 1, 0, "div", 14);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelement(20, "ycn-folderable-move-modal", 15);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵproperty("modalBaseClass", "modal-fix-scroll")("extraModalClasses", "modal-no-border user-select-none")("open", ctx.isOpen);
        i0.ɵɵadvance();
        i0.ɵɵproperty("header", ctx.modalHeader)("showUnsavedStatus", false);
        i0.ɵɵadvance(2);
        i0.ɵɵconditional(ctx.folderableCollectionService.dataParams ? 3 : -1);
        i0.ɵɵadvance(3);
        i0.ɵɵconditional(ctx.folderableCollectionService.textSearchActive ? 6 : 7);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("visibleFlex", false);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(17, _c0, ctx.folderableCollectionService.loading ? "visible" : "hidden"));
        i0.ɵɵadvance(3);
        i0.ɵɵclassProp("multiselect", i0.ɵɵpipeBind1(13, 15, ctx.bulkActionSelectionService.bulkActionMode$));
        i0.ɵɵproperty("id", ctx.folderableCollectionService.scrollableBodyId);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.folderableCollectionService.dataParams);
        i0.ɵɵadvance(2);
        i0.ɵɵconditional(ctx.folderableCollectionService.viewRootFolder && ctx.folderableCollectionService.items ? 16 : !ctx.folderableCollectionService.loading ? 17 : -1);
        i0.ɵɵadvance(2);
        i0.ɵɵconditional(ctx.folderableCollectionService.showLoading && ctx.folderableCollectionService.loading ? 18 : (ctx.folderableCollectionService.paginationInfo == null ? null : ctx.folderableCollectionService.paginationInfo.current_page_num) !== (ctx.folderableCollectionService.paginationInfo == null ? null : ctx.folderableCollectionService.paginationInfo.num_pages) ? 19 : -1);
    } }, dependencies: [i6.NgIf, i6.NgTemplateOutlet, i6.NgStyle, i7.InfiniteScrollDirective, i8.ModalBaseComponent, i9.SimpleModalHeaderComponent, i10.FolderableBulkActionMenuComponent, i11.FolderableColumnHeadersComponent, i12.FolderableMoveModalComponent, i13.FolderBreadcrumbComponent, i14.FolderCreateComponent, i6.AsyncPipe], encapsulation: 2 });
